function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import input from "./input";
var register = {
  parts: ["field", "icon"],
  sizes: input.register.sizes,
  variants: input.register.variants
};
var baseStyle = {
  field: _extends({}, input.baseStyle.field, {
    appearance: "none",
    paddingRight: "2rem",
    paddingBottom: "1px",
    lineHeight: "normal"
  }),
  icon: {
    color: "currentColor",
    fontSize: "1.25rem",
    _disabled: {
      opacity: 0.5
    }
  }
};
var sizes = input.sizes;
var variants = input.variants;
var defaultProps = input.defaultProps;
var select = {
  register,
  defaultProps,
  baseStyle,
  sizes,
  variants
};
export default select;
//# sourceMappingURL=select.js.map